export default __webpack_public_path__ + "static/media/SpartanBold.88d40279.ttf";